import { type UrlMatchResult, type UrlSegment } from '@angular/router';
import { baseRoutes } from '@bizzdesign/shared/utils';
import { actMatcher, keyMatcher } from '@bizzdesign/workspaces/utils';

/* This matcher is for following paths
   { path: 'frames/create' }
   { path: 'frames/:fid' }
*/
export const frameMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  return (
    actMatcher(segments, baseRoutes.frames, 'create') ??
    keyMatcher(segments, baseRoutes.frames, 'fid')
  );
};

/* This matcher is for following paths
   { path: 'views/:vid' }
*/
export const viewsMatcher = (segments: UrlSegment[]): UrlMatchResult | null =>
  keyMatcher(segments, baseRoutes.views, 'vid');

/* This matcher is for following paths
   { path: 'adhocFrames/:fid' }
*/
export const adhocFrameMatcher = (
  segments: UrlSegment[],
): UrlMatchResult | null => {
  return keyMatcher(segments, baseRoutes.adhocFrames, 'fid');
};
